<template>
  <section class="ina_bag_product home-best--seller">
    <div>
      <p class="new_bag_brief" v-html="shopifyData.heading" />
      <div class="new_product_card">
        <div v-for="(value, key) in shopifyData.product" :key="key">
          <a :href="value.productLink" class="product_image">
            <img
              v-lazy="value.productImage"
              alt="Product Image"
              loading="lazy"
              aria-hidden="true"
              aria-label="Product Image"
              width=""
              height=""
            />
          </a>
          <a :href="value.productLink" class="ina_bag_name" v-html="value.productTitle" />
          <span class="ina_bag_price" v-html="value.productPrice" />
        </div>
        <div class="bestSeller_btn">
          <a
            :href="shopifyData.btn_url"
            class="cta_btn cta_btn-black text_center"
            v-html="shopifyData.btn_title"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
.ina_bag_product {
  margin: 10px 15px 30px;
}
.new_bag_brief {
  font-size: 18px;
  color: #000000;
  margin-bottom: 15px;
  line-height: 23px;
  font-family: 'Helvetica', sans-serif;
}

.ina_bag_name {
  color: #4f5050;
  font-size: 12px;
  display: inline-block;
  font-family: 'Helvetica Neue', sans-serif;
}

.ina_bag_price {
  color: #000;
  font-size: 12px;
  line-height: 24px;
  display: block;
  font-family: 'Helvetica', sans-serif;
}

.product_image img {
  width: 100%;
}

.product_image {
  display: block;
}

.new_product_card {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 5px;
}
.text_center {
  text-align: center;
}
.bestSeller_btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 1275px) {
  .new_product_card {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media only screen and (max-width: 991px) {
  .new_product_card {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 768px) {
  /* .ina_bag_name{
        font-size: 9px;
    } */

  .ina_bag_price {
    line-height: 12px;
  }
}
</style>
<style>
@media only screen and (max-width: 991px) {
  .home-best--seller .new_product_card div:nth-child(5n) {
    grid-column: 1 / span 2;
  }
  .home-best--seller .new_product_card div:last-child {
    grid-column: 1 / span 2;
    margin-top: 20px;
  }
}
</style>
